module.exports = __webpack_public_path__ + "img/item_Story_12.16319fd9.jpeg";